import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

interface BackButtonProps {
  to: string;
  className?: string;
}

export function BackButton({ to, className = "" }: BackButtonProps) {
  return (
    <Link
      to={to}
      className={`p-2 rounded-full hover:bg-accent text-muted-foreground transition-colors inline-flex items-center justify-center ${className}`}
      aria-label="Back"
    >
      <ArrowLeft className="w-5 h-5" />
    </Link>
  );
}
